import { FieldValues, Path } from "react-hook-form";
import { TBody } from "./components/tBody";
import { THeader } from "./components/tHeader";
import "./styles.css";
import { TabComponentType } from "types/form";

type PeriodType = {
  id: string;
  periods: string[];
};

export type ReportsType = Record<string, Record<string, number>>;

export type ModelType = {
  reports: ReportsType;
  periods: string[];
};

export type ConfigType = TabComponentType & { requiredPeriods: PeriodType[] };

type Props<T extends FieldValues> = {
  prefix: Path<T>;
};

export const BuhReport = <T extends FieldValues>({ prefix }: Props<T>) => {
  return (
    <div className="buh-report">
      <THeader prefix={prefix} />
      <TBody prefix={prefix} />
    </div>
  );
};
